// extracted by mini-css-extract-plugin
export default {"contentWrapper":"mapProject_contentWrapper__J4T0R","actionsButtons":"mapProject_actionsButtons__52rbS"};